import { useCallback, useEffect, useState } from 'react';
import { throttle } from 'throttle-debounce';

const THROTTLE_DELAY = 150;

export function usePageScroll() {
  const [scrollY, setScrollY] = useState(window.scrollY);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const handleScroll = useCallback(
    throttle(THROTTLE_DELAY, () => {
      setScrollY(window.scrollY);
    }),
    [setScrollY],
  );

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    scrollY,
    scrollToTop: useCallback(() => window.scrollTo(0, 0), []),
  };
}
